import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "payment-item" };
const _hoisted_2 = { class: "payment-item__input" };
const _hoisted_3 = ["value", "id", "disabled"];
const _hoisted_4 = { class: "payment-item__icon" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "payment-item__main" };
const _hoisted_7 = { class: "payment-item__info" };
const _hoisted_8 = ["for"];
const _hoisted_9 = {
    key: 0,
    class: "payment-item__text"
};
const _hoisted_10 = {
    key: 1,
    class: "payment-item__text"
};
import { PaymentItemProps } from "./utils";
import Sprite from "../../../components/Sprite.vue";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaymentItem',
    props: /*@__PURE__*/ _mergeModels({ ...PaymentItemProps }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const value = _useModel(__props, "modelValue");
        const name = props.system.name.replace(/\s*\(.*/, '');
        const subtext = props.system.name.match(/\(.*\)/) ? props.system.name.replace(/.*\((.*)\)/, '$1') : '';
        const src = computed(() => `/img/pay-${props.system.icon}-sm.svg`);
        const id = computed(() => `payment-${props.system.id}`);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "payment",
                        required: "",
                        value: _ctx.system.id,
                        id: id.value,
                        disabled: _ctx.disabled,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((value).value = $event))
                    }, null, 8 /* PROPS */, _hoisted_3), [
                        [_vModelRadio, value.value]
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createVNode(Sprite, { name: "check" })
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                        src: src.value,
                        width: 40,
                        height: 24,
                        alt: ""
                    }, null, 8 /* PROPS */, _hoisted_5)
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("label", {
                            class: "payment-item__label",
                            for: id.value
                        }, _toDisplayString(_unref(name)), 9 /* TEXT, PROPS */, _hoisted_8),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _renderSlot(_ctx.$slots, "suffix")
                    ]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    (!_ctx.disabled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(subtext)), 1 /* TEXT */))
                        : (_ctx.$slots.message)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _renderSlot(_ctx.$slots, "message")
                            ]))
                            : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
